/**
 * Left column Handraise H + flexible body; matches assistant bubble avatar row.
 */

import type { ReactNode } from "react";
import { HandraiseH } from "@/assets/handraise";
import { cn } from "@/lib/utils";

export const AssistantHandraiseRow = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div className={cn("flex w-full items-center", className)}>
    <div className="flex size-7 shrink-0 items-center justify-center">
      <HandraiseH className="size-3" />
    </div>
    <div className="min-w-0 flex-1">{children}</div>
  </div>
);
